import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { identityServices } from '../identityServices'
import { ReportUserPayload } from '../identityTypes'
import { QUERY_KEYS } from '@/constants/queryKeys'

interface UseReportUserOptions {
  onSuccess?: (data: any) => void
  onError?: (error: any) => void
}

export const useReportUser = (options?: UseReportUserOptions) => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: ReportUserPayload) =>
      identityServices.reportUser(payload),
    onSuccess: (data, payload) => {
      if (options?.onSuccess) {
        options.onSuccess(data)
      }
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.IDENTITY_PROFILE, payload.userId],
      })
    },
    onError: (error) => {
      if (options?.onError) {
        options.onError({
          ...error,
          errorMessage: t('api:errors.somethingWrong'),
        })
      }
    },
  })
}
